export class ChangePasswordRequest {
  email!: string;
  oldPassword!: string;
  newPassword!: string;
  confirmPassword!: string;

  constructor() {
  }
}
